var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.80492 1.94141C5.01323 1.94141 1.93945 5.01518 1.93945 8.80687C1.93945 12.5986 5.01323 15.6723 8.80492 15.6723C12.5966 15.6723 15.6704 12.5986 15.6704 8.80687C15.6704 5.01518 12.5966 1.94141 8.80492 1.94141ZM0.689453 8.80687C0.689453 4.32482 4.32287 0.691406 8.80492 0.691406C13.287 0.691406 16.9204 4.32482 16.9204 8.80687C16.9204 13.2889 13.287 16.9223 8.80492 16.9223C4.32287 16.9223 0.689453 13.2889 0.689453 8.80687Z",
    fill: "#111827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5722 13.9643C13.8159 13.7199 14.2117 13.7194 14.456 13.9631L17.3927 16.8922C17.6371 17.136 17.6376 17.5317 17.3939 17.7761C17.1501 18.0205 16.7544 18.021 16.51 17.7772L13.5733 14.8482C13.3289 14.6044 13.3284 14.2087 13.5722 13.9643Z",
    fill: "#111827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.dc7a943eac64a3fa5c3d9d9b45bbdca3.svg";
export { ForwardRef as ReactComponent };